import React from "react";
import styled from "styled-components";
import LandingPageWelcomeImg from "../../../assets/img/landing-page-img.png";
import CardSeparator from "../CardSeparator/CardSeparator";

const HeroContainer = styled.div`
  direction: ltr;
  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

const StyledContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .title {
    align-self: flex-start;
  }
  .description {
    font-size: 1.2rem;
    text-align: justify;
  }
`;

const StyledImg = styled.img`
  width: 100%;
  min-width: 480px;
  max-width: 900px;
`;

const Hero = (props) => {
  const { header, bodyText } = props;
  return (
    <HeroContainer className="row mt-5" data-testid="hero-widget">
      <StyledContent className="col-lg-6">
        <div className="title">
          <h1>{header}</h1>
          <CardSeparator style={props.cardHeader ?? "-lg"} />
        </div>
        <div className="description mt-4">{bodyText}</div>
      </StyledContent>
      <div className="col-lg-6">
        <StyledImg src={LandingPageWelcomeImg} alt="landing-page-welcome-img" />
      </div>
    </HeroContainer>
  );
};

export default Hero;
